import { ArraySelectOptionType } from '@portals/ui-kit';
import { COUNTRY_SELECT_VALUES } from '@/_constants/general';
import { ECountries } from '@/_types';
import flagBy from '../../../../../public/icons/by.svg';
import flagCn from '../../../../../public/icons/cn.svg';
import flagGe from '../../../../../public/icons/ge.svg';
import flagKz from '../../../../../public/icons/kz.svg';
import flagOthers from '../../../../../public/icons/others.svg';
import flagRu from '../../../../../public/icons/ru.svg';
import flagTj from '../../../../../public/icons/tj.svg';

const COUNTRY_OPTIONS: ArraySelectOptionType = [
  {
    id: ECountries.BY,
    title: COUNTRY_SELECT_VALUES.by,
    value: ECountries.BY,
    icon: flagBy,
  },
  {
    id: ECountries.GE,
    title: COUNTRY_SELECT_VALUES.ge,
    value: ECountries.GE,
    icon: flagGe,
  },
  {
    id: ECountries.KZ,
    title: COUNTRY_SELECT_VALUES.kz,
    value: ECountries.KZ,
    icon: flagKz,
  },
  {
    id: ECountries.ZH,
    title: COUNTRY_SELECT_VALUES.zh,
    value: ECountries.ZH,
    icon: flagCn,
  },
  {
    id: ECountries.RU,
    title: COUNTRY_SELECT_VALUES.ru,
    value: ECountries.RU,
    icon: flagRu,
  },
  {
    id: ECountries.TJ,
    title: COUNTRY_SELECT_VALUES.tj,
    value: ECountries.TJ,
    icon: flagTj,
  },
  {
    id: ECountries.EN,
    title: COUNTRY_SELECT_VALUES.other,
    value: ECountries.EN,
    icon: flagOthers,
  },
];

export const getCountryOptions = (
  selectedCountry: string,
): ArraySelectOptionType => {
  return [...COUNTRY_OPTIONS].sort(({ id: firstId }, { id: secondId }) => {
    if (firstId === ECountries.EN) return 1;
    if (secondId === ECountries.EN) return -1;

    if (firstId === selectedCountry) return -1;
    if (secondId === selectedCountry) return 1;

    return 0;
  });
};
